import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import devLogo from '../assets/lcdev.png';

function Footer() {
  const { user } = useAuth();

  return (
    <footer className="bg-green-900 text-white mt-12">
      <div className="container mx-auto px-4 pt-10 pb-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Column 1: Brand & Tagline */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-yellow-400">
              Bolão Copa 2026
            </h3>
            <p className="text-green-100">
              O melhor bolão para torcer juntos pela Seleção Brasileira!
            </p>
          </div>

          {/* Column 2: Navigation Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-yellow-400">
              navegação
            </h3>
            <ul className="space-y-2 text-green-100">
              <li>
                <Link to="/" className="hover:text-yellow-300 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none rounded">
                  Partidas
                </Link>
              </li>
              <li>
                <Link to="/scoreboard" className="hover:text-yellow-300 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none rounded">
                  Classificação
                </Link>
              </li>
              {!user && (
                <>
                  <li>
                    <Link to="/login" className="hover:text-yellow-300 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none rounded">
                      Login
                    </Link>
                  </li>
                  <li>
                    <Link to="/register" className="hover:text-yellow-300 transition-colors focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none rounded">
                      Cadastro
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Column 3: Developer Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-yellow-400">
              crie seu sistema
            </h3>
            <div className="space-y-3 text-green-100 text-sm">
              <p>
                Gostou do site? Construo soluções sob medida para você:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-1 text-xs opacity-90">
                <li>Sistemas Web Personalizados</li>
                <li>Integrações com Inteligência Artificial</li>
                <li>Arquitetura e Soluções em Nuvem</li>
              </ul>
              <p className="pt-2">Fale com Luiz Carlos para um orçamento:</p>
              <div className="space-y-2 pt-1">
                <a 
                  href="https://wa.me/5521995372955?text=Ol%C3%A1%20Luiz,%20gostaria%20de%20falar%20sobre%20desenvolvimento%20de%20software." 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-yellow-300 transition-colors flex items-center gap-2 font-medium"
                >
                  <Smartphone className="w-4 h-4" aria-hidden="true" /> (21) 99537-2955
                </a>
                <a 
                  href="mailto:lcmartinscjr@gmail.com?subject=Orçamento de Desenvolvimento" 
                  className="hover:text-yellow-300 transition-colors flex items-center gap-2 font-medium"
                >
                  <Mail className="w-4 h-4" aria-hidden="true" /> lcmartinscjr@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom border & message */}
        <div className="border-t border-primary-dark mt-8 pt-6 flex flex-col md:flex-row justify-between items-center text-green-200 text-sm">
          <p className="mb-4 md:mb-0">
            Este é um projeto para diversão da família. Torcemos todos juntos pelo Hexa!
          </p>
          <div className="flex items-center gap-3">
            <span>Desenvolvido por</span>
            <img src={devLogo} alt="LC Dev Consulting" className="h-10 object-contain" />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;